import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */


/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isExport, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import TemplateTypeApi from 'api/setting/treatment-templates/template-tpyes.api'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { dateTimeToView } from 'utils/date.utils'
import { exportTemplateTypesToExcel } from './export-excel'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView(),
  isExport: isExport()
}


const initStateErrorMessage = {
  TREATMENT_TEMPLATE_TYPE_NAME: ``,
  IS_DUPLICATE_TREATMENT_TEMPLATE_TYPE_NAME: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_STRING_BASE: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_STRING_EMPTY: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_MAXIMUM_LENGTH: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_ANY_REQUIRED: ``,

  TREATMENT_TEMPLATE_TYPE_NAME_EN: ``,
  IS_DUPLICATE_TREATMENT_TEMPLATE_TYPE_NAME_EN: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_EN_STRING_BASE: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_EN_STRING_EMPTY: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  TREATMENT_TEMPLATE_TYPE_NAME_EN_ANY_REQUIRED: ``
}
export default function TreatmentTemplateTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()



  const [templateTypes, setTemplateTypes] = useState([])
  const [templateTypesExport, setTemplateTypesExport] = useState([])
  const [templateTypeId, setTemplateTypeId] = useState(Number)
  const [templateTypeName, setTemplateTypeName] = useState('')
  const [templateTypeNameEn, setTemplateTypeNameEn] = useState('')
  const [templateTypeStatus, setTemplateTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const componentRef = useRef<HTMLDivElement>(null)
  const [textLength, setTextLength] = useState<number>(0)
  const [textLengthEn, setTextLengthEn] = useState<number>(0)
  const [errorName, setErrorName] = useState<any>()
  const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)
  const [appliedFilters, setAppliedFilters] = useState({
    search: '',
    status: '',
  })
  const prevAppliedFiltersRef = useRef<string>()



  const loadData = async () => {
    try {
      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (appliedFilters.search) condition = { ...condition, search: appliedFilters.search }
      if (appliedFilters.status) condition = { ...condition, status: appliedFilters.status === 'ALL' ? '' : appliedFilters.status }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }

      const resp = await TemplateTypeApi.findAll(condition)
      // const resExport = await TemplateTypeApi.findAll({ ...condition, pageLimit: 99999 })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTemplateTypes(resp.data)
        //  setTemplateTypesExport(resExport.data)
      } else {
        setTemplateTypes([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  const handleExport = async (exportType: 'Excel' | 'PDF') => {
    try {
      let condition: any = {}
      if (appliedFilters.search) condition = { ...condition, search: appliedFilters.search }
      if (appliedFilters.status) condition = { ...condition, status: appliedFilters.status === 'ALL' ? '' : appliedFilters.status }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }

      const resExport = await TemplateTypeApi.findAll({ ...condition, pageLimit: 1000 })

      if (resExport.status === 200) {
        if (exportType === 'Excel') {
          exportTemplateTypesToExcel(resExport.data, t, appliedFilters)
        } else if (exportType === 'PDF') {
          setTemplateTypesExport(resExport.data)
          setTimeout(() => {
            const style = document.createElement("style");
            style.innerHTML = `
              @media print {
                @page { size: landscape }
              }
            `;
            document.head.appendChild(style);
            window.print();
            document.head.removeChild(style);
          }, 100);
        }
      } else {
        notiError('ERROR')
      }
    } catch (error) {
      notiError('ERROR')
    }
  }


  useEffect(() => {
    const stringifiedFilters = JSON.stringify(appliedFilters)

    if (prevAppliedFiltersRef.current && prevAppliedFiltersRef.current !== stringifiedFilters) {
      if (page !== 1) {
        setPage(1)
        return
      }
    }
    loadData()
    prevAppliedFiltersRef.current = stringifiedFilters
  }, [page, pageLimit, sortBy, sortType, appliedFilters])

  const submit = () => {
    setDisabledSubmit(true)
    if (!templateTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ TREATMENT_TEMPLATE_TYPE_NAME: t('TEMPLATE_TYPE.MESSAGE.TEMPLATE_TYPE_NAME') } })
    }


    dispatch(submitModal())
    TemplateTypeApi.create({ treatmentTemplateTypeName: templateTypeName, treatmentTemplateTypeNameEn: templateTypeNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t('TEMPLATE_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!templateTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ TREATMENT_TEMPLATE_TYPE_NAME: t(`TEMPLATE_TYPE.MESSAGE.TEMPLATE_TYPE_NAME`) } })
    }

    dispatch(submitModal())
    TemplateTypeApi.update(templateTypeId, { treatmentTemplateTypeName: templateTypeName, treatmentTemplateTypeNameEn: templateTypeNameEn, status: templateTypeStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t(`TEMPLATE_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setTemplateTypeId(0)
    setTemplateTypeName('')
    setTemplateTypeNameEn('')
    setTemplateTypeStatus('')
    clearErrorMessage()
    setIsOpen(false)
    setTextLength(0)
    setErrorMaxLength(false)
    setTextLengthEn(0)
  }

  const onActive = () => {
    if (id) {
      TemplateTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TEMPLATE_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TEMPLATE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      TemplateTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TEMPLATE_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TEMPLATE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { treatmentTemplateTypeId: tptId, treatmentTemplateTypeName: tptName, treatmentTemplateTypeNameEn: tptNameEn, status: tptStatus } = data
    setTemplateTypeId(tptId)
    setTemplateTypeName(tptName)
    setTemplateTypeNameEn(tptNameEn)
    setTemplateTypeStatus(tptStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '60px' },
    { id: 'templateTypeName', disablePadding: false, label: t('TEMPLATE_TYPE.TABLE.CELL.TEMPLATE_TYPE_NAME') },
    { id: 'templateTypeEn', disablePadding: false, label: t('TEMPLATE_TYPE.TABLE.CELL.TEMPLATE_TYPE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('TEMPLATE_TYPE.TABLE.CELL.STATUS'), width: '200px' },
    { id: 'updatedBy', disablePadding: false, label: t('TEMPLATE_TYPE.TABLE.CELL.UPDATED_BY'), width: '200px' },
    { id: 'action', disablePadding: false, label: 'Action', width: '100px' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { treatmentTemplateTypeId: tptId, treatmentTemplateTypeName: tptName, treatmentTemplateTypeNameEn: tptNameEn, updatedBy, updatedAt, createdAt, status: tptStatus } = objData
    const statusBtnActive = tptStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = tptStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const objRenderData = {
      key: tptId,
      id: tptId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: tptName },
        { option: 'TEXT', align: 'left', label: tptNameEn },
        { option: 'STATUS', align: 'center', label: tptStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt ?? createdAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.treatmentTemplateTypeName)
    setNameEn(obj.treatmentTemplateTypeNameEn)
  }

  const handleTemplateTypeNameChange = (event: any) => {
    const name = event === '' ? '' : String(event)
    const contentLength = name.length
    if (contentLength > 255) {
      setErrorMaxLength(true)
    } else {
      setTemplateTypeName(name)
      setTextLength(contentLength)
      setErrorMaxLength(false)
    }
  }

  const handleTemplateTypeNameEnChange = (event: any) => {
    const nameEn = event === '' ? '' : String(event)
    const contentLength = nameEn.length
    if (contentLength > 255) {
      setErrorMaxLength(true)
    } else {
      setTemplateTypeNameEn(nameEn)
      setTextLengthEn(contentLength)
      setErrorMaxLength(false)
    }
  }

  const filterStatus = (filter: any) => {
    let statusText = t('STATUS.ALL')
    if (filter === 'ACTIVE') {
      statusText = t('STATUS.ACTIVE')
    } else if (filter === 'INACTIVE') {
      statusText = t('STATUS.INACTIVE')
    }
    return statusText
  }


  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TEMPLATE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TEMPLATE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { templateName: name, templateNameEn: nameEn && `(${nameEn})`, status: t(`TEMPLATE_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />

      <HeaderCard text={t('TEMPLATE_TYPE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TEMPLATE_TYPE.SEARCH')}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2} xl={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                setAppliedFilters({ search, status })
              }} />

          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={7} textAlign="right">
            <Box display="flex" justifyContent="end" alignItems="center" width="100%" gap={2}>
              <DropdownButton disabled={permissions?.isExport?.disabled} title='พิมพ์เอกสาร' onChange={(e) => {
                handleExport(e);
              }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
              <MainButton title={t('TEMPLATE_TYPE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={templateTypes.map((val, i) => {
              return renderData(val, i)
            })}
            tableFixedWidth
          />
        </Box>
        <Box
          id="print-table-container"
          ref={componentRef}
        >
          <Typography fontSize="14px" fontWeight={400}>{t('TEMPLATE_TYPE.TITLE')}</Typography>
          <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2}>
            <Typography fontSize="10px" fontWeight={400}> {t('INPUT.SEARCH')}:  {`${appliedFilters.search || '-'}`}</Typography>
            <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {filterStatus(appliedFilters.status)}</Typography>
          </Box>

          <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
            <thead>
              <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('TABLE.NO')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TEMPLATE_TYPE.TABLE.CELL.TEMPLATE_TYPE_NAME')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TEMPLATE_TYPE.TABLE.CELL.TEMPLATE_TYPE_NAME_EN')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'center', width: '150px' }}>{t('TEMPLATE_TYPE.TABLE.CELL.STATUS')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'center', width: '200px' }}>{t('TEMPLATE_TYPE.TABLE.CELL.UPDATED_BY')}</th>
              </tr>
            </thead>
            <tbody>
              {templateTypesExport?.length === 0 &&
                <tr>
                  <td colSpan={9} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                </tr>
              }
              {templateTypesExport.map((data: any, index: number) => (
                <tr key={index}>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentTemplateTypeName || '-'}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentTemplateTypeNameEn || '-'}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '150px' }}>{filterStatus(data.status) || '-'}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '200px' }}>{data.updatedBy || '-'} <br />{dateTimeToView(data.updatedAt ?? data.createdAt) || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
      <PageModal
        title={templateTypeId ? t('TEMPLATE_TYPE.TITLE_UPDATE') : t('TEMPLATE_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('TEMPLATE_TYPE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: templateTypeId ? submitEdit : submit, title: t('TEMPLATE_TYPE.BUTTON.SAVE') }}
      >
        <Box display="flex" flexDirection="column" gap="8px">
          {templateTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setTemplateTypeStatus(templateTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={templateTypeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              handleTemplateTypeNameChange(event.target.value)
              clearErrorMessage()
            }}
            value={templateTypeName}
            label={t('TEMPLATE_TYPE.INPUT.TEMPLATE_TYPE_NAME')}
            helperText={
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_TREATMENT_TEMPLATE_TYPE_NAME ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_STRING_BASE ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_STRING_EMPTY ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_ANY_REQUIRED
            }
            required
            maxLength={255}
          />
          <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${255}`}</Box>
          <TextInput
            onChange={(event) => {
              handleTemplateTypeNameEnChange(event.target.value)
              clearErrorMessage()
            }}
            value={templateTypeNameEn}
            helperText={
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_EN ||
              errorMessage.IS_DUPLICATE_TREATMENT_TEMPLATE_TYPE_NAME_EN ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_EN_STRING_BASE ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_EN_STRING_EMPTY ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_TEMPLATE_TYPE_NAME_EN_ANY_REQUIRED
            }
            label={t('TEMPLATE_TYPE.INPUT.TEMPLATE_TYPE_NAME_EN')}
            maxLength={255}
          />
          <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLengthEn}/${255}`}</Box>
        </Box>
      </PageModal>
    </Box>
  )
}
